'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2; /* eslint-disable */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _adminState = require('redux/modules/adminState');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdminSidebar = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user, adminPage: state.adminState.adminPage };
}, { changeItem: _adminState.changeItem }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(AdminSidebar, _Component);

  function AdminSidebar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AdminSidebar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AdminSidebar.__proto__ || (0, _getPrototypeOf2.default)(AdminSidebar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      actions: [{
        id: 'admincreateuser',
        title: 'Create new user',
        favi: 'fa fa-user-o'
      }],
      search: [{
        id: 'adminusers',
        title: 'Users',
        favi: 'fa fa-user-o'
      }, {
        id: 'adminmodules',
        title: 'Modules',
        favi: 'fa fa-database'
      }, {
        id: 'admingoals',
        title: 'Goals',
        favi: 'fa fa-flag-checkered'
      }, {
        id: 'adminbarriers',
        title: 'Barriers',
        favi: 'fa fa-ban'
      }, {
        id: 'adminstrategies',
        title: 'Strategies',
        favi: 'fa fa-shield'
      }],
      misc: [{
        id: 'adminhelp',
        title: 'Help',
        favi: 'fa fa-question'
      }]
    }, _this.handleOnClick = function (targetadminpage, event) {
      _this.props.changeItem(targetadminpage);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  // used to navigate to a resource item


  (0, _createClass3.default)(AdminSidebar, [{
    key: 'renderListGroup',


    /*
     * Render a list group, list groups are app, extra, activity
     * These are clickable tabs on the sidebar
     */
    value: function renderListGroup(title, type) {
      var _this2 = this;

      var styles = require('./Admin.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h3',
          null,
          title
        ),
        _react2.default.createElement(
          ReactBootstrap.ListGroup,
          null,
          type.map(function (item) {
            return _react2.default.createElement(
              ReactBootstrap.ListGroupItem,
              { className: styles.borderless, key: title + '' + item.title,
                onClick: _this2.handleOnClick.bind(_this2, item.id),
                active: _this2.props.adminPage === item.id },
              _react2.default.createElement(
                ReactBootstrap.Row,
                null,
                _react2.default.createElement(
                  ReactBootstrap.Col,
                  { md: 2, sm: 2, xs: 2 },
                  _react2.default.createElement(
                    'div',
                    { className: styles.favi },
                    _react2.default.createElement('i', { className: item.favi })
                  )
                ),
                _react2.default.createElement(
                  ReactBootstrap.Col,
                  { md: 10, sm: 10, xs: 10 },
                  item.title
                )
              )
            );
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./Admin.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 2, sm: 3, xs: 2, lg: 2, className: styles.sidebar },
          _react2.default.createElement(
            'h2',
            null,
            'Admin Panel'
          ),
          this.renderListGroup('Actions', this.state.actions),
          this.renderListGroup('Search', this.state.search)
        )
      );
    }
  }]);
  return AdminSidebar;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  adminPage: _propTypes2.default.string,
  changeItem: _propTypes2.default.func.isRequired
}, _temp2)) || _class);
/* eslint-enable */

exports.default = AdminSidebar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Admin/AdminSidebar.js
// module id = 1147
// module chunks = 0